import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-review-changed-services",
    prompt: 'Please wait while our team is reviewing changes made to your order. We will email you again once you are ready to continue.',
    briefDescription: 'Review Changes',
    openAction: { 
        text: "Go To Your Order Form",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/order/${guidanceItem.orderId}`
        }
    });



// WEBPACK FOOTER //
// ./src/guidance/items/guidance-review-changed-services.js